import type { WPrezentationTranslations } from "./pl";

export const de: WPrezentationTranslations = {
  empty: "Keine Slides zum Anzeigen.",
  prevSlide: "Vorherige Folie",
  nextSlide: "Nächste Folie",
  cta: "Mehr ansehen",
  openSlideAria: "Öffnen",
  youtubeTitleFallback: "YouTube-Video",
};
